export const cookieStorage = {
	/**
	 * 쿠키 저장
	 * @param key - 쿠키 이름
	 * @param value - 저장할 값 (문자열 또는 객체)
	 * @param options - { days, path }
	 */
	set: (key: string, value: any, options: { days?: number; path?: string } = {}): void => {
		const { days = 7, path = "/" } = options;

		// JSON 객체도 문자열로 변환
		const encodedValue =
			typeof value === "object"
				? encodeURIComponent(JSON.stringify(value))
				: encodeURIComponent(value);

		let expires = "";
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = `; expires=${date.toUTCString()}`;
		}

		document.cookie = `${key}=${encodedValue}${expires}; path=${path}`;
	},

	/**
	 * 쿠키 가져오기
	 * @param key - 쿠키 이름
	 * @returns string | object | null
	 */
	get: (key: string): any => {
		const nameEQ = `${key}=`;
		const ca = document.cookie.split(";");
		for (let c of ca) {
			c = c.trim();
			if (c.indexOf(nameEQ) === 0) {
				const value = decodeURIComponent(c.substring(nameEQ.length));
				try {
					return JSON.parse(value);
				} catch {
					return value;
				}
			}
		}
		return null;
	},

	/**
	 * 쿠키 삭제
	 * @param key - 쿠키 이름
	 * @param path - 기본값 '/'
	 */
	remove: (key: string, path: string = "/"): void => {
		document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;
	},

	/**
	 * 모든 쿠키 초기화
	 */
	clear: (): void => {
		const cookies = document.cookie.split(";");
		for (const cookie of cookies) {
			const eqPos = cookie.indexOf("=");
			const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
			document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
		}
	},
};
